import BaseXMLGenerator from '@/utils/excel/xlsx-tableexport-generator.js'
import { getOrderID, amountFormat } from '@/utils/filters/formatter.js'

function amountFormatBySDK (value) {
  return value
  // return amountFormat(value)
}

var XMLGenerator = new BaseXMLGenerator()
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas, coupons) {
  var rows = []
  for (var dataIdx = datas.length - 1; dataIdx >= 0; --dataIdx) {
    let data = datas[dataIdx]
    var row = []

    var buyerName = '??'
    if (data.BuyerInfo) buyerName = data.BuyerInfo.Name
    else if (data.User) buyerName = data.User.Profile.Name

    var receiverName = '??'
    if (data.ReceiverInfo) receiverName = data.ReceiverInfo.Name

    var receiverPhone = '??'
    if (data.ReceiverInfo) receiverPhone = data.ReceiverInfo.Phone

    var receiverEmail = '??'
    if (data.ReceiverInfo) receiverEmail = data.ReceiverInfo.Email

    var receiverAddress = '??'
    if (data.ReceiverInfo) receiverAddress = `${data.ReceiverInfo.PostalCode}${data.ReceiverInfo.County}${data.ReceiverInfo.Township}${data.ReceiverInfo.Village}${data.ReceiverInfo.Detail}`

    var receiptNumber = '???'
    if (data.ReceiptType === '紙本發票') receiptNumber = data.TripleReceiptID
    if (data.ReceiptType === '電子發票') receiptNumber = data.IsInvoiceIssueDone ? data.InvoiceIssueResult.InvoiceNo : ''

    var firstOrderProduct = null
    if (data.OrderProducts.length) firstOrderProduct = data.OrderProducts[0]
    if (data.OrderProducts.length && data.OrderProducts[0].Product.ProductType ==1) {
      var firstNormalProduct = data.OrderProducts.find(o=>o.Product.ProductType==0)
      if (firstNormalProduct) firstOrderProduct = firstNormalProduct
    }

    function getProductName(orderProduct) {
      if (orderProduct.Product) return orderProduct.Product.Tw.Name
      try {
        var product = JSON.parse(orderProduct.ProductJSON)
        if(product && product.Tw)return product.Tw.Name
      } catch(e) {}
      return '??'
    }

    row.push(getOrderID(data)) // 編號
    row.push(data.OrderStatus) // 訂單狀態
    row.push(data.CreatedAt.substring(0, 10)) // '購買/匯款日'
    row.push(data.ShippedEmailSentAt ? data.ShippedEmailSentAt.substring(0, 10) : '') // 到貨日期
    row.push(buyerName) // 訂購人姓名
    row.push(receiverName) // 收貨人姓名
    row.push(receiverPhone) // 電話
    row.push(receiverEmail) // 電話
    row.push(receiverAddress) // 收貨地址
    row.push('') // 受訂單編號
    row.push(data.TCatLogisticsID) // 宅配單號
    row.push('') // 貨附發票
    row.push(data.OrderProducts.length > 0 ? (
      getProductName(firstOrderProduct)
    ) : '??') // 購買品項
    row.push('') // 重量
    row.push(data.OrderProducts.length > 0 ? amountFormatBySDK(firstOrderProduct.Price) : '??') // 單價
    row.push(data.OrderProducts.length > 0 ? firstOrderProduct.Amount : '??') // 數量
    row.push('' + amountFormatBySDK(data.Amount))// 商品總金額
    row.push('' + amountFormatBySDK(data.UsedVoucherAmount))// 購物金
    row.push('' + amountFormatBySDK(data.CouponDiscount))// 折扣碼
    row.push('' + amountFormatBySDK(data.ShippingCost)) // 運費
    row.push('' + amountFormatBySDK(data.Amount + data.ShippingCost)) // 總金額(含運)
    row.push((data.UsedVoucherAmount+data.CouponDiscount) > 0 ? `${amountFormatBySDK(data.UsedVoucherAmount+data.CouponDiscount)}` : '無') // 折扣方式/金額
    row.push('' + amountFormatBySDK(data.PaidAmount))// 折扣後金額
    row.push('') // 備品貨號
    row.push(data.PaymentMethod) // 付款方式
    row.push('') // 匯款帳號後五碼
    row.push(data.ReceiptType) // 發票類型
    row.push(receiptNumber) // 發票號碼
    row.push(data.ReceiptType === '紙本發票' ? data.ReceiptPaperCompanyTitle : '') // 抬頭
    row.push(data.ReceiptType === '紙本發票' ? data.ReceiptPaperTaxID : data.ReceiptDigitalTaxID) // 統一編號
    row.push('官網') // 顧客類型
    row.push(data.Remark) // 備註
    rows.push(row)

    // 如果訂單有多個商品
    // orderID : getOrderID(data)
    // name : normalOrderProducts[i].Product ? normalOrderProducts[i].Product.Tw.Name : '??'
    // price : amountFormatBySDK(normalOrderProducts[i].Price)
    // amount : normalOrderProducts[i].Amount
    function genRow(orderID, name, price, amount) {
      row = []
      row.push(orderID) // 編號
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push(name) // 購買品項
      row.push('') // 重量
      row.push(price) // 單價
      row.push(amount) // 數量
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      row.push('')
      return row
    }
    // 1. 顯示一般商品
    var normalOrderProducts = data.OrderProducts.filter(o=>o.Product.ProductType==0)
    for (var i = 0; i < normalOrderProducts.length; i++) {
      if (normalOrderProducts[i].ID == firstOrderProduct.ID) continue
      try {
        row = genRow(
          getOrderID(data), 
          getProductName(normalOrderProducts[i]),
          amountFormatBySDK(normalOrderProducts[i].Price),
          normalOrderProducts[i].Amount
        )
        rows.push(row)
      } catch (e) {
        console.error(`export order excel, error data id: ${data.ID}, i=${i}`)
      }
    }
    // 2. 顯示贈品
    for (var i = 0; i < data.OrderGifts.length; i++) {
      try {
        row = genRow(
          getOrderID(data), 
          data.OrderGifts[i].Gift ? '贈品：'+data.OrderGifts[i].Gift.NameTw : '??', 
          0,
          data.OrderGifts[i].Amount
        )
        rows.push(row)
      } catch (e) {
        console.error(`export order excel, error data id: ${data.ID}, i=${i}`)
      }
    }
    // 3. 顯示折扣碼
    if (data.CouponID) {
      var coupon = coupons.find(o=>o.ID == data.CouponID)
      try {
        row = genRow(
          getOrderID(data), 
          `折扣碼：${coupon ? coupon.NameTw : data.CouponCode}`, 
          amountFormatBySDK(0-data.CouponDiscount),
          0
        )
        rows.push(row)
      } catch (e) {
        console.error(`export order excel, error data id: ${data.ID}, i=${i}`)
      }
    }

    // 4. 顯示加價購
    var additionalOrderProducts = data.OrderProducts.filter(o=>o.Product.ProductType==1)
    for (var i = 0; i < additionalOrderProducts.length; i++) {
      if (additionalOrderProducts[i].ID == firstOrderProduct.ID) continue
      try {
        row = genRow(
          getOrderID(data), 
          '加購價：'+getProductName(additionalOrderProducts[i]),
          amountFormatBySDK(additionalOrderProducts[i].Price),
          additionalOrderProducts[i].Amount
        )
        rows.push(row)
      } catch (e) {
        console.error(`export order excel, error data id: ${data.ID}, i=${i}`)
      }
    }
  }

  let headerList = ['編號', '訂單狀態', '購買/匯款日', '到貨日期', '訂購人姓名', '收貨人姓名', '電話', 'Email', '收貨地址', '受訂單編號', '宅配單號', '貨附發票',
    '購買品項', '重量', '單價', '數量', '商品總金額', '購物金', '折扣碼', '運費', '總金額(含運)', '折扣方式/金額', '折扣後金額', '備品貨號', '付款方式', '匯款帳號後五碼', '發票類型', '發票號碼', '抬頭', '統一編號', '顧客類型', '備註']
  let typeList = [
    'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string',
    'string', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string', 'string'
  ]
  return this.baseGenerate(rows, headerList, typeList)
}

export default XMLGenerator
